import { createActionCreator } from 'deox';
import { OptionFilter, Categories, Category } from '@/types';
import { CategoryForm } from '@/services/service-directory/category';

export const fetchCategoriesActions = {
  request: createActionCreator(
    'FETCH_CATEGORIES_REQUEST',
    (resolve) => (entryType: string, industry?: string | undefined) => resolve({ entryType, industry })
  ),
  success: createActionCreator(
    'FETCH_CATEGORIES_SUCCESS',
    (resolve) => (entryType: string, filterOptions: { [checkbox: string]: OptionFilter }, categories: Categories) =>
      resolve({ entryType, filterOptions, categories })
  ),
  failure: createActionCreator('FETCH_CATEGORIES_FAILURE', (resolve) => (error: any) => resolve({ error })),
};

export const fetchCategoryByIdActions = {
  request: createActionCreator('FETCH_CATEGORY_REQUEST', (resolve) => (id: string) => resolve({ id })),
  success: createActionCreator('FETCH_CATEGORY_SUCCESS', (resolve) => (category: Category) => resolve(category)),
  failure: createActionCreator('FETCH_CATEGORY_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const createCategoryActions = {
  request: createActionCreator('CREATE_CATEGORY_REQUEST', (resolve) => (categoryInfo: CategoryForm) =>
    resolve({ categoryInfo })
  ),
  success: createActionCreator('CREATE_CATEGORY_SUCCESS'),
  failure: createActionCreator('CREATE_CATEGORY_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const editCategoryActions = {
  request: createActionCreator('EDIT_CATEGORY_REQUEST', (resolve) => (id: string, categoryInfo: CategoryForm) =>
    resolve({ id, categoryInfo })
  ),
  success: createActionCreator('EDIT_CATEGORY_SUCCESS'),
  failure: createActionCreator('EDIT_CATEGORY_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const deleteCategoryActions = {
  request: createActionCreator('DELETE_CATEGORY_REQUEST', (resolve) => (id: string, entryType: string) =>
    resolve({ id, entryType })
  ),
  success: createActionCreator('DELETE_CATEGORY_SUCCESS'),
  failure: createActionCreator('DELETE_CATEGORY_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};
